export default "__VITE_ASSET__DmNOr$b6__"